import React, { useState, useEffect } from "react";
import Lottie from "lottie-react";

import animationData from "../../../public/assets/animations/superadmin.json";

import {
  superAdminLogin,
  Verify_admin_superadminLogin__otp,
} from "../CrudOperations/PostOperation";
import { useDispatch } from "react-redux";
import { signIn, updateAdministrator } from "../ReduxStore/Slices/auth";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { forgotPassword } from "./forgotPassword";

const AdminSuperAdminAuth = () => {
  const [loading, setLoading] = useState(false);
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [forgotMode, setForgotMode] = useState(false); // 👈 new toggle
  const [employeeId, setEmployeeId] = useState("");
  const [name, setName] = useState("");
  const [newPassword, setNewPassword] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    console.log(userName);
    console.log(password);

    const response = await superAdminLogin({
      userName,
      password,
    });
    console.log(response);

    if (response?.Message == "Success") {
      toast.success(response.Message);

      dispatch(
        signIn({
          Employee_Name: response.Name,
          Employee_id: response.EmployeeId,
          Status: "Logged In",
          Message: response.Message,
          token: response.Token,
        })
      );

      localStorage.setItem("token", response.Token);
      localStorage.setItem("Employee_Name", response.Name);
      localStorage.setItem("Employee_id", response.EmployeeId);
      localStorage.setItem("Status", "Logged In");

      navigate(`/${response.Token}/dashboard`);
    } else {
      toast.error(response.Message || response.error);
    }
    setLoading(false);
  };

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setLoading(true);

    const response = await forgotPassword({
      EmployeeId: employeeId,
      Name: name,
      NewPassword: newPassword,
    });
    console.log(response);

    if (response?.Message == "Password changed successfully.") {
      console.log(response);

      toast.success("Password Updated Successfully");
      setForgotMode(false);
    } else {
      toast.error(response?.Message || response?.error);
    }

    setLoading(false);
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-r from-green-100 via-yellow-200 to-yellow-300">
      <div className="w-full max-w-md p-8 bg-white rounded-lg shadow-lg relative overflow-hidden">
        <Lottie
          animationData={animationData}
          loop={true}
          className="absolute top-0 left-0 w-full h-full opacity-30"
        />
        <div className="relative z-10 ">
          <div className="flex items-center flex-col gap-3 w-full   px-5  pb-3">
            <img
              className="w-20 h-20"
              src="https://assets.telegraphindia.com/telegraph/2020/Aug/1597389993_img_20200814_125036.jpg"
              alt="logo"
            />
          </div>

          <h2 className="text-3xl font-extrabold text-center mb-6 text-gray-800">
            Administrator
          </h2>

          {/* Toggle between login and forgot password form */}
          {!forgotMode ? (
            // 🔐 Login Form (existing code remains as-is)
            <form onSubmit={handleSubmit}>
              <div className="mb-4">
                <label className="block text-gray-700 font-medium">
                  User Name
                </label>
                <input
                  type="text"
                  value={userName}
                  onChange={(e) => setUserName(e.target.value)}
                  className="w-full p-3 mt-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>

              <div className="mb-4">
                <label className="block text-gray-700 font-medium">
                  Password
                </label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full p-3 mt-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>

              <button
                type="submit"
                className="w-full p-3 mt-4 text-white bg-blue-600 rounded-md shadow-md hover:bg-blue-700"
              >
                Login
              </button>

              <div className="mt-4 text-center">
                <button
                  type="button"
                  onClick={() => setForgotMode(true)}
                  className="text-sm text-red-600 hover:underline"
                >
                  Forgot Password?
                </button>
              </div>
            </form>
          ) : (
            // 🔄 Forgot Password Form
            <form onSubmit={handleForgotPassword}>
              <div className="mb-4">
                <label className="block text-gray-700 font-medium">
                  Employee ID
                </label>
                <input
                  type="text"
                  value={employeeId}
                  onChange={(e) => setEmployeeId(e.target.value)}
                  className="w-full p-3 mt-2 border border-gray-300 rounded-md"
                  required
                />
              </div>

              <div className="mb-4">
                <label className="block text-gray-700 font-medium">Name</label>
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="w-full p-3 mt-2 border border-gray-300 rounded-md"
                  required
                />
              </div>

              <div className="mb-4">
                <label className="block text-gray-700 font-medium">
                  New Password
                </label>
                <input
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  className="w-full p-3 mt-2 border border-gray-300 rounded-md"
                  required
                />
              </div>

              <button
                type="submit"
                className="w-full p-3 bg-green-600 text-white rounded-md shadow-md hover:bg-green-700"
              >
                Reset Password
              </button>

              <div className="mt-4 text-center">
                <button
                  type="button"
                  onClick={() => setForgotMode(false)}
                  className="text-sm text-blue-600 hover:underline"
                >
                  Back to Login
                </button>
              </div>
            </form>
          )}

          {/* <div className="mt-6 text-center">
            <button
              onClick={() => {
                toast.warn(
                  "This Functionality is not available yet!!"
                );
              }}
              className="w-full p-3 bg-red-600 text-white rounded-md shadow-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500"
            >
             Forgot Password
            </button>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default AdminSuperAdminAuth;
